import type { TypingUser } from "./useMessages";

/** "Alex is typing…" row with three bouncing dots. */
export function TypingIndicator({ users }: { users: TypingUser[] }) {
  if (users.length === 0) return null;
  const label =
    users.length === 1
      ? `${users[0].name} is typing`
      : users.length === 2
        ? `${users[0].name} and ${users[1].name} are typing`
        : `${users.length} people are typing`;
  return (
    <div className="flex items-center gap-2 px-3 py-1.5 text-[12px] text-slate-400">
      <span className="flex items-end gap-0.5" aria-hidden>
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-1.5 w-1.5 rounded-full bg-slate-500 animate-bounce"
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </span>
      <span className="truncate">{label}…</span>
    </div>
  );
}
